<template>
  <div class="gameboy-body">
    <div class="gameboy-screen-container">
      <div class="gameboy-header">
        <div class="power-light"></div>
        <span class="power-text">BATTERY</span>
      </div>
      
      <div class="gameboy-screen-wrapper">
        <div class="gameboy-screen" ref="screen" @scroll="handleScroll">
          <div class="housewarming-page">
            <h1>Birthday Time!</h1>
            <h1>🗓️12/09/26🗓️</h1>
            <h1>🎂</h1>
            <h1>I'm Getting Old!</h1>
            <h1>🎉</h1>
            <div class="flex-grid-thirds">
              <div class="sml-col"/>
              <div class="col">
                <p>In September I am delighted to be turning <i>AN AGE</i><a href="#myagefoot" id="myageref"><sup>1</sup></a>!</p> 
                <p>I would love for you to come celebrate with us in our home in Kent on <b>Saturday the 12th of September</b>.</p>
                <h1>⏰</h1>
                <p>Show up anytime from 1pm.</p>
                <h1>🍕</h1>
                <p>We will provide Gluten Free and Veggie/Vegan food, feel free to bring snacks and food yourself, if you would like.</p>
                <h1>🥂</h1>
                <p>We will provide alcoholic and non-alcoholic drinks, feel free to bring your own too, if you would like.</p>
                <h1>🚂 🚘</h1>
                <p>Our closest station is Folkestone Central (10 min walk).</p>
                <p>There is free (time limited) parking near us and plenty of parking in town.</p>
                <h1>🏖️</h1>
                <p>We are a short walk from the beach! Feel free to explore the area and come and go as you please obvs.</p>
                <h1>🚫🎁</h1>
                <p>Can we get you anything? Absolutely not! Just your wonderful company please.</p>
                <p>🇵🇸🏳️‍⚧️If you feel compelled to treat me please donate to a charity in support of Palestine or trans rights.🇵🇸🏳️‍⚧️</p>
                <div class="container">
                  <h2 class="centered">See you Soooon x</h2>
                  <img src="../assets/Cake-Cut.jpeg" class="housewarming-footer" title="Cake is repsentative of possible future cake!"/>
                </div>
                <p id="myagefoot"><a href="#myageref"><sup>1</sup></a> One year older than last year of course!</p>
              </div>
              <div class="sml-col"></div>
            </div>
          </div>
        </div>
        
        <!-- The fog of war overlay -->
        <div class="fog-overlay"></div>

        <!-- The sprite overlay -->
        <div class="sprite-overlay" :class="{ walking: isWalking, up: facingUp }" :style="{ marginLeft: spriteX + 'px' }">
          <div class="sprite-bouncer">
            <img src="../assets/mage.png" class="sprite" alt="Walking Mage" />
          </div>
        </div>
      </div>
      <div class="gameboy-logo">
        <span class="logo-text">Birthday Boy</span><span class="logo-tm">™</span>
      </div>
    </div>
    
    <div class="gameboy-controls">
      <div class="d-pad" :class="pressedBtn">
        <button class="d-pad-btn up" @mousedown="startScroll(-1, 'up')" @mouseup="stopScroll" @mouseleave="stopScroll" @touchstart.prevent="startScroll(-1, 'up')" @touchend.prevent="stopScroll"></button>
        <button class="d-pad-btn right" @mousedown="startMove(1, 'right')" @mouseup="stopScroll" @mouseleave="stopScroll" @touchstart.prevent="startMove(1, 'right')" @touchend.prevent="stopScroll"></button>
        <button class="d-pad-btn down" @mousedown="startScroll(1, 'down')" @mouseup="stopScroll" @mouseleave="stopScroll" @touchstart.prevent="startScroll(1, 'down')" @touchend.prevent="stopScroll"></button>
        <button class="d-pad-btn left" @mousedown="startMove(-1, 'left')" @mouseup="stopScroll" @mouseleave="stopScroll" @touchstart.prevent="startMove(-1, 'left')" @touchend.prevent="stopScroll"></button>
        <div class="d-pad-center"></div>
      </div>
    </div>

    <div class="speaker-grill">
      <div class="speaker-slit"></div>
      <div class="speaker-slit"></div>
      <div class="speaker-slit"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Birthday',
  data() {
    return {
      isWalking: false,
      facingUp: false,
      scrollInterval: null,
      scrollTimeout: null,
      lastScrollTop: 0,
      pressedBtn: null,
      spriteX: 0,
      moveInterval: null
    };
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
  },
  methods: {
    handleScroll(e) {
      const currentScrollTop = e.target.scrollTop;
      this.facingUp = currentScrollTop < this.lastScrollTop;
      this.lastScrollTop = currentScrollTop;
      
      this.isWalking = true;
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.isWalking = false;
      }, 150);
    },
    startScroll(direction, btn) {
      if (this.pressedBtn === btn) return; // prevent auto-repeat
      this.pressedBtn = btn;
      this.isWalking = true;
      this.facingUp = direction < 0;
      clearInterval(this.scrollInterval);
      clearInterval(this.moveInterval);
      this.scrollInterval = setInterval(() => {
        if (this.$refs.screen) {
          this.$refs.screen.scrollTop += direction * 5;
        }
      }, 20);
    },
    startMove(direction, btn) {
      if (this.pressedBtn === btn) return; // prevent auto-repeat
      this.pressedBtn = btn;
      this.isWalking = true;
      clearInterval(this.moveInterval);
      clearInterval(this.scrollInterval);
      this.moveInterval = setInterval(() => {
        const newX = this.spriteX + (direction * 4);
        // Constrain to edges of the screen
        if (newX >= -90 && newX <= 90) {
          this.spriteX = newX;
        }
      }, 20);
    },
    pressOnly(btn) {
      this.pressedBtn = btn;
    },
    stopScroll(btn) {
      if (typeof btn === 'string' && this.pressedBtn !== btn) return;
      this.pressedBtn = null;
      clearInterval(this.scrollInterval);
      clearInterval(this.moveInterval);
      this.scrollInterval = null;
      this.moveInterval = null;
      this.isWalking = false;
    },
    handleKeyDown(e) {
      // Prevent default scrolling and handle movement
      switch(e.key) {
        case 'ArrowUp':
          e.preventDefault();
          this.startScroll(-1, 'up');
          break;
        case 'ArrowDown':
          e.preventDefault();
          this.startScroll(1, 'down');
          break;
        case 'ArrowLeft':
          e.preventDefault();
          this.startMove(-1, 'left');
          break;
        case 'ArrowRight':
          e.preventDefault();
          this.startMove(1, 'right');
          break;
      }
    },
    handleKeyUp(e) {
      switch(e.key) {
        case 'ArrowUp':
          this.stopScroll('up');
          break;
        case 'ArrowDown':
          this.stopScroll('down');
          break;
        case 'ArrowLeft':
          this.stopScroll('left');
          break;
        case 'ArrowRight':
          this.stopScroll('right');
          break;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
    clearInterval(this.scrollInterval);
    clearInterval(this.moveInterval);
    clearTimeout(this.scrollTimeout);
  }
}
</script>

<style scoped>
  /* Base layout to center the Game Boy */
  .gameboy-body {
    background-color: #d8d8d8;
    border-radius: 10px 10px 50px 10px;
    padding: 30px 20px 60px 20px;
    width: 350px;
    margin: 40px auto;
    box-shadow: 10px 10px 20px rgba(0,0,0,0.3), inset -5px -5px 15px rgba(0,0,0,0.1);
    border: 2px solid #b0b0b0;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }

  /* The grey border around the screen */
  .gameboy-screen-container {
    background-color: #555;
    border-radius: 10px 10px 40px 10px;
    padding: 20px 30px 30px 30px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    border: 2px solid #333;
  }

  .gameboy-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .power-light {
    width: 10px;
    height: 10px;
    background-color: #ff3333;
    border-radius: 50%;
    box-shadow: 0 0 5px #ff3333;
  }

  .power-text {
    font-size: 0.6em;
    color: #b0b0b0;
    margin-left: 5px;
    font-family: sans-serif;
    letter-spacing: 1px;
  }

  .gameboy-screen-wrapper {
    position: relative;
    width: 100%;
    height: 300px;
    border: 4px solid #222;
    background-color: #9bbc0f;
    border-radius: 5px;
    overflow: hidden;
  }

  .gameboy-logo {
    position: absolute;
    bottom: 6px;
    left: 30px;
    color: #a3a7a9;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 15px;
    font-weight: 900;
    font-style: italic;
    letter-spacing: 2px;
    user-select: none;
    -webkit-user-select: none;
  }
  
  .logo-tm {
    font-size: 8px;
    vertical-align: top;
    margin-left: 2px;
    font-style: normal;
    letter-spacing: 0;
  }

  /* The actual scrolling green screen */
  .gameboy-screen {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
  }
  .gameboy-screen::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  .fog-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    background: radial-gradient(circle at center, transparent 20%, rgba(15, 56, 15, 0.95) 80%);
    z-index: 5;
  }

  /* Sprite Overlay */
  .sprite-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 64px;
    height: 64px;
    pointer-events: none; /* don't block scrolling */
  }

  .sprite-bouncer {
    width: 100%;
    height: 100%;
  }

  .sprite {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: sepia(1) hue-rotate(50deg) saturate(3);
  }

  .sprite-overlay.walking .sprite-bouncer {
    animation: bob 0.3s infinite alternate steps(2);
  }

  .sprite-overlay.walking .sprite {
    animation: walkFlip 0.6s infinite steps(1);
  }
  
  .sprite-overlay.up .sprite-bouncer {
    transform: scaleY(-1);
  }

  @keyframes bob {
    from { transform: translateY(0); }
    to { transform: translateY(-6px); }
  }

  @keyframes walkFlip {
    0%, 100% { transform: scaleX(1); }
    50% { transform: scaleX(-1); }
  }

  /* Old styles adapted */
  .housewarming-page {
    text-align: center;
    font-size: 16px;
    color: #0f380f;
    padding: 150px 0; /* Huge padding so we can scroll past the start/end */
    font-weight: bold;
  }

  .housewarming-footer {
    width: 90%; 
    height: 100%;
    filter: grayscale(100%) sepia(100%) hue-rotate(50deg) saturate(3) contrast(1.2);
    border: 4px solid #0f380f;
    border-radius: 4px;
    margin-top: 10px;
  }

  h1 {
    font-size: 1.5em; /* Scaled down for small screen */
    text-align: center;
    margin-left: 3px;
    margin-right: 3px;
    color: #0f380f;
    display: block;
    font-family: 'Press Start 2P', cursive;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 0.8em;
    color: #0f380f;
    text-align: center;
    display: block;
    font-family: 'Press Start 2P', cursive;
    background-color: rgba(155, 188, 15, 0.9);
    padding: 5px;
    border-radius: 4px;
  }

  .flex-grid-thirds {
    display: flex;
    justify-content: center;
  }

  .col {
    width: 90%;
    background-color: #8bac0f;
    border: 4px solid #0f380f;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 4px 4px 0px #0f380f;
    margin: 20px auto;
  }

  .sml-col {
    display: none;
  }

  .container {
    position: relative;
    text-align: center;
    color: #0f380f;
  }
  
  .centered {
    position: absolute;
    left: 10%;
    right: 10%;
    top: 20%;
  }

  /* D-Pad Styles */
  .gameboy-controls {
    margin-top: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
  }

  .d-pad {
    position: relative;
    width: 90px;
    height: 90px;
    background: transparent;
    transition: transform 0.1s ease-out;
  }

  /* Speaker Grill */
  .speaker-grill {
    position: absolute;
    bottom: 30px;
    right: 25px;
    display: flex;
    gap: 8px;
    transform: rotate(-25deg);
    user-select: none;
    -webkit-user-select: none;
  }

  .speaker-slit {
    width: 8px;
    height: 55px;
    background-color: #b0b0b0;
    border-radius: 4px;
    box-shadow: inset 2px 2px 5px rgba(0,0,0,0.4), inset -1px -1px 2px rgba(255,255,255,0.7);
  }

  .d-pad.up { transform: perspective(300px) rotateX(15deg); }
  .d-pad.down { transform: perspective(300px) rotateX(-15deg); }
  .d-pad.left { transform: perspective(300px) rotateY(-15deg); }
  .d-pad.right { transform: perspective(300px) rotateY(15deg); }

  .d-pad-btn {
    position: absolute;
    background-color: #222;
    border: none;
    border-radius: 4px;
    box-shadow: inset -2px -2px 0px rgba(0,0,0,0.5), inset 2px 2px 0px rgba(255,255,255,0.2), 2px 2px 5px rgba(0,0,0,0.3);
    cursor: pointer;
    z-index: 2;
    transition: background-color 0.1s, box-shadow 0.1s;
  }

  .d-pad-btn:active {
    box-shadow: inset 2px 2px 5px rgba(0,0,0,0.8);
    background-color: #181818;
  }

  .d-pad-btn.up {
    top: 0;
    left: 30px;
    width: 30px;
    height: 35px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .d-pad-btn.down {
    bottom: 0;
    left: 30px;
    width: 30px;
    height: 35px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .d-pad-btn.left {
    top: 30px;
    left: 0;
    width: 35px;
    height: 30px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .d-pad-btn.right {
    top: 30px;
    right: 0;
    width: 35px;
    height: 30px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .d-pad-center {
    position: absolute;
    top: 30px;
    left: 30px;
    width: 30px;
    height: 30px;
    background-color: #222;
    z-index: 1;
  }
</style>
